import React from 'react';
import '../../styles/Itinerary.css';

const TermsAndCondition = () => (
  <div className="terms-condition-section">
    <h2>Terms and Conditions</h2>
    <ul className="terms-condition-list">
      <li>
        The above given rates are valid only during the mentioned period.
      </li>
      <li>
        Any change in the date of travel or the number of persons travelling the tour cost offered may vary.
      </li>
      <li>
        Similar category hotels will be arranged if rooms are unavailable in above listed hotels as per the required dates.
      </li>
      <li>
        Some hotels provide only mattress in case when extra bed is required and not cot.
      </li>
      <li>
        Any extra bed/breakfast/ Lunch for Members which is not mentioned has to be paid directly to the hotel by guests as per the hotel policy.
      </li>
      <li>
        Early check-in or late check-out is subject to availability and the hotel may charge extra for the same.
      </li>
      <li>
        Booking will be confirmed only after receiving the advance payment and based on availability of hotels mentioned.
      </li>
      <li>
        Some sightseeing spots might be closed on certain days, and we won't be able to compensate if travelling falls on those days.
      </li>
      <li>
        Company is not responsible for missing sightseeing, destinations due to political strike or roadblocks.
      </li>
      <li>
        Swayourway Tours & Travels does not have any hidden charges except your lunch, during the journey if someone asks for extra money, you may inform us and we will not be responsible if you pay the amount without our concern.
      </li>
      <li>
        During the tour, if you face any difficulty or lag in service, it should be informed to the concerned Trip Advisor at the earliest to act upon immediately.
      </li>
    </ul>
  </div>
);

export default TermsAndCondition;
